import styles from "@/components/directory/v2/EVsResultsManager.module.css";
import EVsListsManager from "@/components/directory/v2/list-view/EVsListsManager";
import EVsCardsManager from "@/components/directory/v2/card-view/EVsCardsManager";

const EVsResultsManager = ({results, loading, displayMode}) => {
  return (
    <div className={styles.container}>
      {displayMode === 'list' ? (
        <EVsListsManager results={results}/>
      ) : (
        <EVsCardsManager results={results}/>
      )}
    </div>
  );
}

export default EVsResultsManager;